module.exports = __webpack_public_path__ + "static/media/ilo_contacto.48507ce7.png";